import PropTypes from 'prop-types'
import {
  Table, Button,
} from 'antd'
import { EditOutlined, /* DeleteOutlined, */ PlusOutlined } from '@ant-design/icons'
import history from 'utils/history'

const GovermentList = ({
  data,
}) => {
  const columns = [
    {
      title: 'No',
      dataIndex: 'id',
      key: 'id',
      width: 80,
      render: text => text,
    },
    {
      title: 'Judul',
      dataIndex: 'title',
      key: 'title',
      render: text => text || '',
    },
    {
      title: 'Konten',
      dataIndex: 'content',
      key: 'content',
      ellipsis: true,
      render: text => text || '-',
    },
    {
      title: 'URL',
      dataIndex: 'url',
      key: 'url',
      render: text => text || '-',
    },
    {
      title: 'Action',
      dataIndex: '',
      key: 'action',
      width: 80,
      render: (text, record) => (
        <div className="d-flex justify-content-center">
          <EditOutlined onClick={() => history.push(`/goverment/${record.id}/edit`)} />
        </div>
      ),
    },
  ]

  return (
    <div>
      <div className="pb-3">
        <div className="btn-primary-wrapper d-flex justify-content-between mb-4">
          <h3 className="title-content mb-0">List Bantuan Pemerintah</h3>
          <Button type="primary" icon={<PlusOutlined />} onClick={() => history.push('/goverment/add')}>
            Add Bantuan Pemerintah
          </Button>
        </div>
      </div>
      <Table
        rowKey="id"
        className="table-striped-rows"
        columns={columns}
        dataSource={data.data}
        loading={data.isFetching}
        pagination={false}
      />
    </div>
  )
}

GovermentList.propTypes = {
  data: PropTypes.object,
}

export default GovermentList
